<template>
    <div>
      <a-form id="formLogin"
                class="user-layout-login"
                ref="formLogin"
                :form="form">
          <!--大框  -->
              <!-- 手机号 -->
<!-- 密码 -->
<a-form-item style="margin-bottom: 10px;">
              <a-input-password size="default"
                                placeholder="请输入密码"
                                v-decorator="[
                  'password',
                  {rules: [{ required: true, message: `请输入密码！` }], validateTrigger: 'blur'}
                ]">
                <a-icon slot="prefix"
                        type="lock"
                        :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input-password>
            </a-form-item>

            <!-- 确认密码 -->
            <a-form-item has-feedback validate-status="success" style="margin-bottom: 10px;">
              <a-input-password size="default"
                                placeholder="确认密码"
                                v-decorator="[
                  'password',
                  {rules: [{ required: true, message: `确认密码！` }], validateTrigger: 'blur'}
                ]">
                <a-icon slot="prefix"
                        type="lock"
                        :style="{ color: 'rgba(0,0,0,.25)' }" />
              </a-input-password>
            </a-form-item>
  
          <!-- 自动登录、忘记密码 -->
          <!-- 忘记密码无页面!!! -->
          <!-- <a-form-item>
            <a-checkbox v-decorator="['rememberMe', { valuePropName: 'checked' }]">{{ $t('user.login.remember-me') }}</a-checkbox>
            <router-link :to="{ name: 'recover', params: { user: 'aaa'} }"
                         class="forge-password"
                         style="float: right;">{{ $t('user.login.forgot-password') }}</router-link>
          </a-form-item> -->
    
          <!--  登录按钮  -->
          <a-form-item>
            <a-button 
            style="width: 100%;margin-top: 2px;"
            size="large"
                      type="primary"
                      htmlType="submit"
                      class="login-button"
                      :loading="state.loginBtn"
                      :disabled="state.loginBtn">下一步</a-button>
        
            
          </a-form-item>
        </a-form>
    </div>
  </template>
  
  <script>
  export default {
      data() {
        return {
          form: this.$form.createForm(this),
          customActiveKey: 'account',
          state: {
            time: 60,
            loginBtn: false,
            // login type: 0 email, 1 username, 2 telephone
            loginType: 0,
            smsSendBtn: false
          }
        }
      },
  }
  </script>
  
  <style>
    .getCaptcha {
        display: block;
        width: 100%;
        height: 50px;
      }
      .steps {
      max-width: 550px;
      margin: 16px auto;
    }
  </style>